import React from "react";
import { toUrl } from "../../../lib/config";
import MegaParkLogo from "../../../assets/images/megapark.png";
import "../../../assets/styles/about-mvg.scss";

/* ---------- Tipler ---------- */
export type Block = {
  title: string;
  text: string; // HTML kabul ediyor (br vb.)
};

export type Goals = {
  accentTitle: string;
  restTitle: string;
  items: string[];
};

export type CorporateValues = {
  accentTitle: string;     // "Kurumsal"
  restTitle: string;        // "Değerler"
  text: string;             // paragraf
};

export type AboutMVGProps = {
  mission: Block;
  vision: Block;
  goals: Goals;
  corporateValues?: CorporateValues; // <-- YENİ
  logoSrc?: string;
  logoAlt?: string;
  accentColor?: string;
  maxWidth?: number;
};

/* ---------- Bileşen ---------- */
const AboutMVG: React.FC<AboutMVGProps> = ({
  mission,
  vision,
  goals,
  corporateValues, // <-- YENİ
  logoSrc,
  logoAlt = "Kurumsal Logo",
  accentColor = "#2ba87a",
  maxWidth = 1200,
}) => {
  const cssVars: React.CSSProperties = {
    // @ts-ignore
    "--mvg-accent": accentColor,
    "--mvg-max": `${maxWidth}px`,
  };

  const ImgWithFallback: React.FC<{ src?: string; alt?: string; className?: string }> = ({ src, alt, className }) => {
    const input = (src || "").trim();
    let abs = "";
    if (!input) {
      abs = "";
    } else if (/^https?:\/\//i.test(input)) {
      // absolute URL
      abs = input;
    } else if (input.startsWith('/api/')) {
      // backend-served media (already includes route)
      abs = toUrl(input);
    } else {
      // assume UUID -> backend media route
      abs = toUrl(`/api/media/${input}`);
    }
    const [current, setCurrent] = React.useState(abs);
    return (
      <img
        src={current}
        alt={alt || ''}
        className={className}
        style={{ maxWidth: 280, width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
        crossOrigin="anonymous"
        loading="eager"
        onError={(e) => {
          const cur = e.currentTarget.getAttribute('src') || '';
          let next = MegaParkLogo as unknown as string;
          if (!next || next === cur) {
            next = MegaParkLogo as unknown as string;
          }
          if (next && next !== cur) e.currentTarget.src = next;
        }}
      />
    );
  };

  return (
    <section className="about-mvg" style={cssVars} aria-labelledby="mvg-mission">
      <div className="mvg-container">
        {/* ÜST GRID */}
        <div className="mvg-grid">
          <div className="mvg-col">
            <article className="mvg-block" id="mvg-mission">
              <h2 className="mvg-title">{mission.title}</h2>
              <span className="mvg-underline" aria-hidden="true" />
              <p
                className="mvg-text"
                dangerouslySetInnerHTML={{ __html: mission.text }}
              />
            </article>

            <article className="mvg-block" id="mvg-vision">
              <h2 className="mvg-title">{vision.title}</h2>
              <span className="mvg-underline" aria-hidden="true" />
              <p
                className="mvg-text"
                dangerouslySetInnerHTML={{ __html: vision.text }}
              />
            </article>
          </div>

          {logoSrc ? (
            <aside className="mvg-logo" aria-label="kurumsal logo">
              <ImgWithFallback src={logoSrc} alt={logoAlt} />
            </aside>
          ) : null}
        </div>

        {/* ALT: Amaçlar & Hedefler */}
        <section className="mvg-goals" aria-labelledby="mvg-goals-title">
          <h3 id="mvg-goals-title" className="mvg-goals-title">
            <span className="accent">{goals.accentTitle}</span>{" "}
            <span className="rest">{goals.restTitle}</span>
          </h3>
          <span className="mvg-underline right" aria-hidden="true" />

          <ol className="mvg-goals-list">
            {goals.items.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ol>
        </section>

        {/* ALT: Kurumsal Değerler  (isteğe bağlı) */}
        {corporateValues && (
          <section
            className="mvg-values"
            aria-labelledby="mvg-values-title"
          >
            <h3 id="mvg-values-title" className="mvg-values-title">
              <span className="accent">{corporateValues.accentTitle}</span>{" "}
              <span className="rest">{corporateValues.restTitle}</span>
            </h3>
            <span className="mvg-underline thin" aria-hidden="true" />
            <p className="mvg-values-text">
              {corporateValues.text}
            </p>
          </section>
        )}
      </div>
    </section>
  );
};

export default AboutMVG;
